<template src='./bankBalance.pug' lang='pug'></template>

<script>
import moment from 'moment'
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import axios from '../../../../../build/http-requests/axios-common.js'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import selectTag from '../../../../events/selectTag'

export default {
  name: 'BankBalance',

  components: {
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('saldoBancario.labels.contasBancarias'),
            sub: this.$t('saldoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      groupingOptions: {
        prop: 'grupo.id',
        groupIdProp: 'id',
        headerNameProp: 'nome',
        defaultIdGroup: '0'
      },
      groups: [],
      gridId: '#SaldoConta',
      treeGridCfg: {},
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      audit: {},
      dateRange: {},
      bankAccountsSelected: [],
      bankAccountsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'SaldoBancario',
      error: false,
      msgError: '',
      disableSearchButton: false,
      idsItensSelected: []
    }
  },

  methods: {
    validate () {
      const self = this
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result && self.$refs.dateRange.validate()) {
            self.showTreegrid = true
            startTreeGridLoading(self.gridId)
            self.search().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    search () {
      this.disableSearchButton = true
      let filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        lang: language.getCookieByName('language')
      }

      return new Promise((resolve, reject) => {
        axios.post('/bankBalance/', { filter: filter }).then((response) => {
          if (window.Grids[0]) {
            window.DisposeGrids()
          }
          this.result = response.data
          response.data.Body[0].forEach(item => {
            if (item.NomeEstabelecimentoGrupo === '') {
              item.NomeEstabelecimentoGrupo = this.$t('contaBancaria.labels.semGrupo')
            }
          })
          this.treeGridCfg = response.data.Cfg.Layout
          this.showTreegrid = true
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
          reject()
        })
      })
    },

    async openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      const bankAccounts = await this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list')
      this.data.bankAccounts.allBankAccounts = bankAccounts.data.data
      this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
        return !bankAccount.ativo
      })
      this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
        return bankAccount.ativo
      })
      const groups = await this.$store.dispatch('getEstablishmentGroups')
      this.groups = groups
      this.groups.push({
        id: 0,
        nome: this.$t('contaBancaria.labels.semGrupo')
      })
      this.shown.bankAccounts = true
    },

    closeModal () {
      this.shown.bankAccounts = false
    }
  },

  mounted () {
    selectTag.$on('tagsSelected', (tags, idsItensSelected) => {
      this.bankAccountsTags = tags
      this.idsItensSelected = idsItensSelected
    })
  }
}
</script>

<style lang='css' scoped>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// BankBalance.vue?73036000